import React, { ReactNode } from "react"
import { Tabs } from "antd"

interface IManageFilter {
  ManagedCampaignsTable: ReactNode
  UnmanagedCampaignsTable: ReactNode
}

const ManageFilter: React.FC<IManageFilter> = ({
  ManagedCampaignsTable,
  UnmanagedCampaignsTable,
}) => {
  const items = [
    {
      key: "1",
      label: "Managed",
      children: ManagedCampaignsTable,
    },
    {
      key: "2",
      label: "Unmanaged",
      children: UnmanagedCampaignsTable,
    },
  ]

  return <Tabs defaultActiveKey="1" items={items} destroyInactiveTabPane={true} />
}

export default ManageFilter
